import React from 'react'

const Investors = () => {
  return (
    <div>
      
    </div>
  )
}

export default Investors